import { ActivityDto, DescriptionDto, ExternalLinkDto, SlimDocumentDto } from "../services/generated";
import { LocalContentProcessDto } from "../services/generated/models/LocalContentProcessDto";
import { ViewUnitDto } from "../services/generated/models/ViewUnitDto";

export class LocalContentProcessModel implements LocalContentProcessDto {
  public id: number;
  public title: string;
  public description: DescriptionDto | null;
  public documents: Array<SlimDocumentDto> | null;
  public externalLinks: Array<ExternalLinkDto> | null;
  public activityInputs: Array<ActivityDto> | null;
  public activityOutputs: Array<ActivityDto> | null;
  public unit: ViewUnitDto | null;
  public url: string = '';
  public unitTitle: string = '';


  constructor(localContentProcess: LocalContentProcessDto) {
    this.id = localContentProcess.id;
    this.title = localContentProcess.title;
    this.description = localContentProcess.description;
    this.documents = localContentProcess.documents;
    this.externalLinks = localContentProcess.externalLinks;
    this.activityInputs = localContentProcess.activityInputs;
    this.activityOutputs = localContentProcess.activityOutputs;
    this.unit = localContentProcess.unit;

    Object.defineProperty(this, 'url', {
      get() {
        return `/unit/${this.unit.id}/process/${this.id}`;
      }
    });

    Object.defineProperty(this, 'unitTitle', {
      get() {
        return this.unit?.title || '';
      }
    });
  }
}